export const LOCALES = {
  ENGLISH: 'en-EN',
  RUSSIAN: 'ru-RU'
}

export enum LOCALES_ENUM {
  ENGLISH = 'en-EN',
  RUSSIAN = 'ru-RU'
}